import React from "react";
import addSpacesInString from "../../util/addSpacesInString";
import labelMotifsInSequence from "../../util/labelMotifsInSequence";
import {
  Card,
  CardBody,
  Table,
} from "reactstrap";

/**
 * Display prediction result field.
 * @param {object} props {activeColor: xxx, predictionResult: xxx}
 */
const ShowPredictionResult = (props) => {
  const predictionResult = props.predictionResult;
  const activeColor = props.activeColor !== null ? props.activeColor : "success";
  const textColor = "text-" + activeColor;
  const textBackgroundColor = "bg-" + activeColor;

  const resultCards = [];
  if (predictionResult !== null) {
    for (const result of predictionResult) {
      const sequenceId = result.sequenceId;
      const sequence = result.sequence;
      const sequenceTitle = <h3 id={sequenceId} className={textColor}><strong>{sequenceId}</strong></h3>;
      if (result.contained_motifs.length === 0) {
        const entry = <div key={sequenceId}>
          <Card>
            <CardBody>
              {sequenceTitle}
              <p><strong>Prediction Results Summary: </strong></p>
              <p>This sequence does not contain any predicted motifs.</p>
              <p><strong>{sequenceId}: </strong></p>
              <p>{sequence}</p>
              <a href="#prediction_summary" style={{paddingTop:0}}>
                Back to the prediction summary
              </a>
            </CardBody>
          </Card>
        </div>
        resultCards.push(entry);
      } else {
        const patternContainer = []
        for (const motif of result.contained_motifs) {
          const motifName = <h6 key={motif} className={textColor}>{motif}</h6>
          const motifPredictionDetail = result.motifs[motif];

          const tableRows = []; 
          const sites = {};
          for (const matchedSequenceInfo of motifPredictionDetail.matched_sequences){
            let tableRow = <tr key={matchedSequenceInfo.startIndex}>
              <td>{matchedSequenceInfo.startIndex} - {matchedSequenceInfo.startIndex + matchedSequenceInfo.matched_sequence.length - 1}</td>
              <td className="text-wrap">{addSpacesInString(matchedSequenceInfo.matched_sequence)}</td>
            </tr>
            if (sites[matchedSequenceInfo.startIndex] === undefined 
              || sites[matchedSequenceInfo.startIndex] === null 
              || sites[matchedSequenceInfo.startIndex] < matchedSequenceInfo.startIndex + matchedSequenceInfo.matched_sequence.length - 1) {
              sites[matchedSequenceInfo.startIndex] = matchedSequenceInfo.startIndex + matchedSequenceInfo.matched_sequence.length - 1;
            }
            tableRows.push(tableRow);
          }
          
          const motifEntry = <div key={motif}>
            {motifName}
            <p><strong>Pattern Signature: </strong>{motifPredictionDetail.pattern_signature}</p>
            <p><strong>Sequence  highlighted with the predicted <span className={textColor}>{motif} motif</span>: </strong>{labelMotifsInSequence(sequence, sites, textBackgroundColor)}</p>
            <Table className="table table-hover table-bordered w-100 text-wrap">
              <thead className="thead-light">
                <tr>
                  <th scope="col" className="w-25">Location</th>
                  <th scope="col" className="w-75">Matched Sub-sequences</th>
                </tr>
              </thead>
              <tbody style={{fontFamily: "Monospace"}}>
                {tableRows}
              </tbody>
            </Table>
          </div>
          patternContainer.push(motifEntry);
        }
        const entry = <div key={sequenceId}>
          <Card>
            <CardBody>
              {sequenceTitle}
              <p><strong>Prediction Results Summary: </strong></p>
              <p>This sequence contains <strong>{result.contained_motifs.length}</strong> predicted motif(s): <strong className={textColor}>[{result.contained_motifs.join(", ")}]</strong>.</p>
              <p><strong>{sequenceId}: </strong></p>
              <p>{sequence}</p>
              <a href="#prediction_summary" style={{paddingTop:0}}>
                Back to the prediction summary
              </a>
              <hr />
              {patternContainer}
            </CardBody>
          </Card>
        </div>
        resultCards.push(entry);
      }
    }
  }

  return <div>{resultCards}</div>;
}

export default ShowPredictionResult;